import { useState } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Results from './components/Results';
import Benefits from './components/Benefits';
import Pricing from './components/Pricing';
import ConsultationCTA from './components/ConsultationCTA';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FAFAF8] to-[#F5F5F3]">
      <Hero />
      <Problem />
      <Solution />
      <Results />
      <Benefits />
      <Pricing />
      <ConsultationCTA />
      <FinalCTA />
      <Footer />
    </div>
  );
}
